import { PARENT_HEADER } from 'src/app/chat/~store/actions/constants';
import { v4 as uuidv4 } from 'uuid';

const REACT_APP_JWT_ACCOUNT_FIELD_NAME = process.env.REACT_APP_JWT_ACCOUNT_FIELD_NAME;

const EXTERNAL_ID_URL_PARAM = "externalId";

export const getExternalId = (): string => {
    const newExternalId = (): string => {
        const e = uuidv4();
        try {
            localStorage.setItem('externalId', e);
        } catch (err) {

        } finally {
            return e;
        }
    }

    const tryGetExternalIdFromUrl = (): string | undefined => {
        const externalId = getUrlParam(EXTERNAL_ID_URL_PARAM);
        if (typeof (externalId) != "string" || externalId === "null" || externalId === "undefined" || externalId.length == 0) return undefined;
        return externalId;
    }

    const tryGetExternalIdFromJwt = (): string | undefined => {
        const jwt = getUrlParam("account");
        if (typeof (jwt) != "string" || jwt === "null" || jwt === "undefined" || jwt.length == 0 || !REACT_APP_JWT_ACCOUNT_FIELD_NAME) return undefined;
        var base64Url = jwt.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload)[REACT_APP_JWT_ACCOUNT_FIELD_NAME];
    }

    try {
        if (window.externalId === undefined) {
            window.externalId = tryGetExternalIdFromJwt() ??
             tryGetExternalIdFromUrl() ?? 
             localStorage.getItem('externalId')?.replace(/\s+/g, '') ?? 
             newExternalId();
        } 
    } catch (err) {
        console.error(err);
    }

    if (window.externalId === undefined) {
        window.externalId = newExternalId();
    }

    return encodeURIComponent(window.externalId);
}

export const getUrlParam = (param: string): string => {
    const urlParams = new URLSearchParams(window.location.search);
    let urlParam = urlParams.get(param);
    urlParam = (urlParam === null || urlParam == undefined || urlParam === "null" || urlParam === "undefined") ? "" : urlParam;
    return  urlParam;
}

export const getParentHeader = (): string => {
    try{
        return getUrlParam(PARENT_HEADER);
    }
    catch(e) {
        console.error(e);
        return window.location.origin;
    }
}